import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { LocationState } from "~/constants";
import { useLazySetupIntentsIndexQuery } from "~/store/api";

export const useClientSecret = (): string | null => {
  const location = useLocation();
  const [clientSecret, setClientSecret] = useState<string | null>(null);
  const [apiSetupIntentsIndex] = useLazySetupIntentsIndexQuery();

  const state = location.state as LocationState | null;
  const type = state?.type;

  useEffect(() => {
    if (!type) return;

    (async () => {
      const responseBody = await apiSetupIntentsIndex().unwrap();
      const { clientSecret } = responseBody;

      setClientSecret(clientSecret);
    })();
  }, [apiSetupIntentsIndex, type]);

  return clientSecret;
};
